import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import BaseCloseBtn from '@/components/v2/BaseCloseBtn';
import BaseImageThumbnail from '@/components/v2/BaseImageThumbnail';
import OrderDetails from '@/components/v2/ecommerce/OrderDetails';
import { ORDER } from '@/helpers/constants/Store';
/**
 * Constant for Vuex Order Module Namespace
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version 0.0.16
 */
const namespace = { namespace: ORDER };
/**
 * Order Details Dialog Component
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version 0.1.6
 */
let TheOrderDetailsDialog = class TheOrderDetailsDialog extends Vue {
};
__decorate([
    Prop({ type: String, required: true })
], TheOrderDetailsDialog.prototype, "orderUuid", void 0);
__decorate([
    Getter('toggleOrderDetails', namespace)
], TheOrderDetailsDialog.prototype, "toggleOrderDetails", void 0);
__decorate([
    Mutation('hideOrderDetails', namespace)
], TheOrderDetailsDialog.prototype, "hideOrderDetails", void 0);
TheOrderDetailsDialog = __decorate([
    Component({
        components: {
            BaseCloseBtn,
            BaseImageThumbnail,
            OrderDetails,
        },
    })
], TheOrderDetailsDialog);
export default TheOrderDetailsDialog;
